export default import.meta.ROLLDOWN_FILE_URL_kMdHHYAW2dQoXbLjilgvBw